'use client';

// import { getOrCreateIdentity } from '@/actions/flagsmith-identity';
// import useUserContext from '@/hooks/useUserContext';
// import { useFlags } from 'flagsmith/react';
// import { useEffect } from 'react';

export function useNewHeader() {
  // const { new_header } = useFlags(['new_header']);
  // const { identity } = useUserContext();

  // useEffect(() => {
  //   // add an identity to cookie on first identity load, where the value is 'undefined'
  //   // after login, the identity is set to the user's email
  //   // after logout, the identity is set to a new uuid
  //   // so it's never back to 'undefined'
  //   Promise.resolve(getOrCreateIdentity(identity));

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // if (!new_header.enabled) {
  //   return false;
  // }

  // return new_header.value;
  return true;
}
